/**
 * @file Owns the Three.js scene and its environment settings.
 */

import * as THREE from 'three';

export class SceneManager {
  /**
   * @param {import('../config/GameConfig.js').GameConfig} config Game config.
   */
  constructor(config) {
    /** @type {THREE.Scene} */
    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color(config.renderer.clearColor);

    const { fog } = config.renderer;
    // Fog hides the arena edge and gives the flat-shaded look some depth.
    this.scene.fog = new THREE.Fog(fog.color, fog.near, fog.far);
  }

  /**
   * Removes every child added after construction.
   * @returns {void}
   */
  clear() {
    this.scene.clear();
  }

  /**
   * @returns {void}
   */
  dispose() {
    this.scene.clear();
  }
}
